import propertyFA from './fa/fa.json'

const PropertyMessages = {
  fa: { ...propertyFA },
}

export default PropertyMessages
